import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import Wordmark from '../components/Wordmark';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="border-b border-[#e0ddd8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-5">
          <Wordmark />
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 py-12 sm:py-16">
        <div className="w-full max-w-md">
          <h1
            className="text-3xl sm:text-4xl font-normal mb-3 leading-tight"
            style={{ fontFamily: 'Instrument Serif, serif' }}
          >
            Forgot password
          </h1>

          {sent ? (
            <div
              data-testid="forgot-password-sent-message"
              className="bg-[#f5f3ef] border border-[#e0ddd8] rounded-lg p-6"
            >
              <p className="text-[#1a1a1a]">
                If an account exists for <strong>{email}</strong>, you'll receive a reset link shortly.
              </p>
              <Link
                to="/login"
                className="inline-block mt-4 text-sm text-[#0a5c44] hover:underline"
              >
                Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <p className="text-[#1a1a1a]/70 mb-8">
                Enter your email and we'll send you a link to reset your password.
              </p>

              {error && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm mb-6">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <Label htmlFor="email" className="text-base font-normal text-[#1a1a1a]">
                    Email
                  </Label>
                  <Input
                    id="email"
                    data-testid="forgot-password-email-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="bg-white border-[#e0ddd8] mt-2"
                    placeholder="you@company.com"
                    required
                  />
                </div>

                <Button
                  type="submit"
                  data-testid="forgot-password-submit-button"
                  disabled={loading}
                  className="w-full bg-[#1a1a1a] text-white hover:bg-[#2a2a2a] transition-colors h-11"
                >
                  {loading ? 'Sending...' : 'Send reset link'}
                </Button>
              </form>

              <p className="text-sm text-[#1a1a1a]/60 mt-6 text-center">
                Remember your password?{' '}
                <Link to="/login" className="text-[#0a5c44] hover:underline">
                  Sign in
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
